import React from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

const SimpleBackdrop = (props) => {
  console.log(props.backdropState)
  const classes = useStyles();
  // const [open, setOpen] = React.useState(props.backdropState);
  return (
    <div>
      <Backdrop className={classes.backdrop} open={props.backdropState}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}

export default SimpleBackdrop